import React, { Component, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Spinner,
  Button,
} from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';

import { getLaporan } from '../../actions/AfadaAction';
import { DELETE_LAPORAN, GET_TOKEN } from 'utils';

import swal from 'sweetalert';
import axios from 'axios';
import { logOutUser } from 'actions/AuthAction';
import jwt_decode from 'jwt-decode';

export default function ListAfada() {
  const dispatch = useDispatch();
  const history = useHistory();

  // auth

  const [token, setToken] = useState('');

  const [nama, setNama] = useState('');
  const [username, setUsername] = useState('');
  const [akses, setAkses] = useState('');
  const [expire, setExpire] = useState('');
  const [idAdmin, setIdAdmin] = useState('1');

  const [accessToken, setAccessToken] = useState('');

  const refreshToken = async () => {
    try {
      const response = await axios.get(GET_TOKEN + '/token');
      setToken(response.data);
      const decoded = jwt_decode(response.data.accessToken);
      setNama(decoded.nama);
      setUsername(decoded.username);
      setAccessToken(response.data.accessToken);
      setAkses(decoded.akses.split(','));
      setExpire(decoded.exp);
      setIdAdmin(decoded.idAdmin);
    } catch (error) {
      if (error.response) {
        dispatch(logOutUser(history));
        history.push('/');
      }
    }
  };

  const axiosJWT = axios.create();

  axiosJWT.interceptors.request.use(
    async (config) => {
      const currentDate = new Date();
      if (expire * 1000 < currentDate.getTime()) {
        const response = await axios.get(GET_TOKEN + '/token');
        config.headers.Authorization = `Bearer ${response.data.accessToken}`;
        setToken(response.data.accessToken);
        const decoded = jwt_decode(response.data.accessToken);
        setNama(decoded.nama);
        setUsername(decoded.username);
        setAkses(decoded.akses);
        setIdAdmin(decoded.idAdmin);
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  //auth

  const { getListLaporanError, getListLaporanLoading, getListLaporanResult } =
    useSelector((state) => state.LaporanReducer);

  useEffect(() => {
    dispatch(getLaporan());
    refreshToken();
  }, []);

  const removeData = async (id) => {
    try {
      await axios.delete(DELETE_LAPORAN + `${id}`, {
        credential: 'include',
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      swal('Sukses!', 'Laporan berhasil dihapus', 'success');
      history.push('/admin');
      history.push('/admin/afada');
    } catch (error) {
      swal('Failed!', 'Forbiden', 'error');
    }
  };

  return (
    <div className='content'>
      <Row>
        <Col md='12'>
          <Card>
            <CardHeader>
              <CardTitle tag='h4'>Postingan Forum RSS</CardTitle>
            </CardHeader>
            <CardBody style={{ overflowX: 'auto' }}>
              <Table>
                <thead className='text-primary'>
                  <tr>
                    <th>Id</th>
                    <th>Foto</th>
                    <th>Judul</th>
                    <th>instansi</th>
                    <th>Jenis</th>

                    <th>Lokasi</th>
                    <th>Publikasi</th>
                    <th>Sifat</th>
                    <th>Status</th>
                    <th>Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  {getListLaporanResult ? (
                    Object.keys(getListLaporanResult).map((key) => (
                      <tr key={key}>
                        <td>{getListLaporanResult[key].id}</td>
                        <td>
                          <img
                            src={getListLaporanResult[key].foto.split(',')[0]}
                            width='100'
                            alt={getListLaporanResult[key].judul}
                          />
                        </td>
                        <td>{getListLaporanResult[key].judul}</td>
                        <td>{getListLaporanResult[key].instansi}</td>
                        <td>{getListLaporanResult[key].jenis} </td>

                        <td>{getListLaporanResult[key].lokasi} </td>
                        <td>{getListLaporanResult[key].publikasi} </td>
                        <td>{getListLaporanResult[key].sifat} </td>
                        <td>{getListLaporanResult[key].status} </td>
                        <td>
                          <Link
                            className='btn btn-warning'
                            to={
                              '/admin/afada/edit/' +
                              getListLaporanResult[key].id +
                              ',' +
                              idAdmin
                            }
                          >
                            <i className='nc-icon nc-ruler-pencil'></i> TL
                          </Link>
                        </td>
                        <td>
                          <Button
                            color='danger'
                            className='ml-2'
                            onClick={() =>
                              removeData(getListLaporanResult[key].id)
                            }
                          >
                            <i className='nc-icon nc-basket'></i> Hapus
                          </Button>
                        </td>
                      </tr>
                    ))
                  ) : getListLaporanLoading ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        <Spinner color='primary' />
                      </td>
                    </tr>
                  ) : getListLaporanError ? (
                    <tr>
                      <td colSpan='6' align='center'>
                        {getListLaporanError}
                      </td>
                    </tr>
                  ) : (
                    <tr>
                      <td colSpan='6' align='center'>
                        Data Kosong
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
